import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "gatsby-theme-ui-blog"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <strong>
      <p><inlineCode parentName="p">{`gatsby-theme-ui-blog`}</inlineCode>{` package was deprecated after Theme UI v0.3.1.`}</p>
    </strong>
    <hr></hr>
    <h1 {...{
      "id": "gatsby-theme-ui-blog"
    }}>{`gatsby-theme-ui-blog`}</h1>
    <p>{`Minimal Gatsby MDX blog theme built with Theme UI. Use this as a starting point
for building custom blog themes with Theme UI.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i gatsby-theme-ui-blog
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// gatsby-config.js
module.exports = {
  plugins: ['gatsby-theme-ui-blog'],
}
`}</code></pre>
    <h2 {...{
      "id": "shadowing"
    }}>{`Shadowing`}</h2>
    <p>{`Shadow the following components to customize styles and page layout:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Component`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Props`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`src/gatsby-theme-ui-blog/posts.js`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Index page for all blog posts`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{ posts }`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`src/gatsby-theme-ui-blog/post.js`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Full blog post article page`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`{ title, date, children, keywords, tags }`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`src/gatsby-theme-ui-blog/layout.js`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Wrapping layout component for the Post and Posts components`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`all page-level props`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "theming"
    }}>{`Theming`}</h2>
    <p>{`Use `}<inlineCode parentName="p">{`gatsby-plugin-theme-ui`}</inlineCode>{` to override or customize the theme.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i gatsby-plugin-theme-ui
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// gatsby-config.js
module.exports = {
  plugins: ['gatsby-theme-ui-blog', 'gatsby-plugin-theme-ui'],
}
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// shadow src/gatsby-plugin-theme-ui/index.js
import base from 'gatsby-theme-ui-blog/src/gatsby-plugin-theme-ui'

const theme = {
  ...base,
  colors: {
    text: 'white',
    background: 'black',
    primary: 'cyan',
    secondary: 'magenta',
  },
}

export default theme
`}</code></pre>
    <h2 {...{
      "id": "options"
    }}>{`Options`}</h2>
    <p>{`This theme is based off of `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/gatsby-theme-blog-core"
      }}>{`gatsby-theme-blog-core`}</a>{` and uses all the same
options.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Key`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default value`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`basePath`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Root url for all blog posts`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`contentPath`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`content/posts`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Location of blog posts`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`assetPath`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`content/assets`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Location of assets`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`mdx`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Configure `}<inlineCode parentName="td">{`gatsby-plugin-mdx`}</inlineCode>{` (if your website already is using the plugin pass `}<inlineCode parentName="td">{`false`}</inlineCode>{` to turn this off)`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      